import RecruitmentConstants from "../constants/recruitment-constants";
import hiringManagementService from "../services/Recruitment/hiring-management-service";
import interviewManagementService from "../services/Recruitment/interview-management-service";
import notificationTemplateService from "../services/Recruitment/notification-template-service";
import recruitmentRequirementService from "../services/Recruitment/recruitment-requirement-service";
import recruitmentSettingService from "../services/Recruitment/recruitment-setting-service";
import recruitmentStatisticsService from "../services/Recruitment/recruitment-statistics-service";
import resumeLibraryService from "../services/Recruitment/resume-library-service";

const dataMode = 1;

// hiring management
function changeHiringManagementAction (filters = {}, status = "loading", counter = 1) {
	return {
		type: RecruitmentConstants.ActionTypes.CHANGEHIRINGMANAGEMENT,
		payload: {
			filters: filters,
			status: status,
			counter: counter
		}
	}
}
export function changeHiringManagement (filters = {}, status = "loading", counter = 1) {
	return dispatch => dispatch(changeHiringManagementAction(filters, status, counter));
}
export function selectHiringManagement (gets, callback) {
	let apiLoadStatus = false;
	return dispatch => {
		hiringManagementService.selectHiringManagement(gets, res => {
			apiLoadStatus = true;
			if (res.data.Success || 1 === dataMode) {
				dispatch({
					type: RecruitmentConstants.ActionTypes.SELECTHIRINGMANAGEMENT,
					payload: {
						data: res.data,
						status: "loaded"
					}
				});
			}else{
				dispatch(changeHiringManagementAction({}, "error", 0));
			}
		}, err => {
			apiLoadStatus = true;
			dispatch(changeHiringManagementAction({}, "error", 0))
		})
		setTimeout(() => {
			if (!apiLoadStatus) {
				dispatch(changeHiringManagementAction({}, "loading", 0))
			}
		}, 100);
	}
}




// interview management
function changeInterviewManagementAction (filters = {}, status = "loading", counter = 1) {
	return {
		type: RecruitmentConstants.ActionTypes.CHANGEINTERVIEWMANAGEMENT,
		payload: {
			filters: filters,
			status: status,
			counter: counter
		}
	}
}
export function changeInterviewManagement (filters = {}, status = "loading", counter = 1) {
	return dispatch => dispatch(changeInterviewManagementAction(filters, status, counter));
}
export function selectInterviewManagement (gets, callback) {
	let apiLoadStatus = false;
	return dispatch => {
		interviewManagementService.selectInterviewManagement(gets, res => {
			apiLoadStatus = true;
			if (res.data.Success || 1 === dataMode) {
				dispatch({
					type: RecruitmentConstants.ActionTypes.SELECTINTERVIEWMANAGEMENT,
					payload: {
						data: res.data,
						status: "loaded"
					}
				});
			}else{
				dispatch(changeInterviewManagementAction({}, "error", 0));
			}
		}, err => {
			apiLoadStatus = true;
			dispatch(changeInterviewManagementAction({}, "error", 0))
		})
		setTimeout(() => {
			if (!apiLoadStatus) {
				dispatch(changeInterviewManagementAction({}, "loading", 0))
			}
		}, 100);
	}
}




// notification template
function changeNotificationTemplateAction (filters = {}, status = "loading", counter = 1) {
	return {
		type: RecruitmentConstants.ActionTypes.CHANGENOTIFICATIONTEMPLATE,
		payload: {
			filters: filters,
			status: status,
			counter: counter
		}
	}
}
export function changeNotificationTemplate (filters = {}, status = "loading", counter = 1) {
	return dispatch => dispatch(changeNotificationTemplateAction(filters, status, counter));
}
export function selectNotificationTemplate (gets, callback) {
	let apiLoadStatus = false;
	return dispatch => {
		notificationTemplateService.selectNotificationTemplate(gets, res => {
			apiLoadStatus = true;
			if (res.data.Success || 1 === dataMode) {
				dispatch({
					type: RecruitmentConstants.ActionTypes.SELECTNOTIFICATIONTEMPLATE,
					payload: {
						data: res.data.Object,
						status: "loaded"
					}
				});
			}else{
				dispatch(changeNotificationTemplateAction({}, "error", 0));
			}
		}, err => {
			apiLoadStatus = true;
			dispatch(changeNotificationTemplateAction({}, "error", 0))
		})
		setTimeout(() => {
			if (!apiLoadStatus) {
				dispatch(changeNotificationTemplateAction({}, "loading", 0))
			}
		}, 100);
	}
}
export function updateNotificationTemplate (puts, index, callback) {
	return dispatch => notificationTemplateService.updateNotificationTemplate(puts, res => {
		if ("function" === typeof callback) {
			callback(res);
		}
		if (res.data.Success) {
			dispatch({
					type: RecruitmentConstants.ActionTypes.UPDATENOTIFICATIONTEMPLATE,
					payload: {
						data: puts,
						index: index
					}
			});
		}
	})
}



// recruitment requirement
function changeRecruitmentRequirementAction (filters = {}, status = "loading", counter = 1) {
	return {
		type: RecruitmentConstants.ActionTypes.CHANGERECUITMENTREQUIREMENT,
		payload: {
			filters: filters,
			status: status,
			counter: counter
		}
	}
}
export function changeRecruitmentRequirement (filters = {}, status = "loading", counter = 1) {
	return dispatch => dispatch(changeRecruitmentRequirementAction(filters, status, counter));
}
export function selectRecruitmentRequirement (gets, callback) {
	let apiLoadStatus = false;
	return dispatch => {
		recruitmentRequirementService.selectRecruitmentRequirement(gets, res => {
			apiLoadStatus = true;
			if (res.data.Success || 1 === dataMode) {
				dispatch({
					type: RecruitmentConstants.ActionTypes.SELECTRECUITMENTREQUIREMENT,
					payload: {
						data: res.data.Object,
						status: "loaded"
					}
				});
			}else{
				dispatch(changeRecruitmentRequirementAction({}, "error", 0));
			}
		}, err => {
			apiLoadStatus = true;
			dispatch(changeRecruitmentRequirementAction({}, "error", 0));
		})
		setTimeout(() => {
			if (!apiLoadStatus) {
				dispatch(changeRecruitmentRequirementAction({}, "loading", 0))
			}
		}, 100);		
	}
}
export function updateRecruitmentRequirement (puts, index, callback) {
	return dispatch => recruitmentRequirementService.updateRecruitmentRequirement(puts, res => {
		if ("function" === typeof callback) {
			callback(res);
		}
		if (res.data.Success) {
			dispatch({
				type: RecruitmentConstants.ActionTypes.UPDATERECUITMENTREQUIREMENT,
				payload: {
					data: puts,
					index: index
				}
			})
		}
	})
}



// recruitment setting
function changeRecruitmentSettingAction (filters = {}, status = "loading", counter = 1) {
	return {
		type: RecruitmentConstants.ActionTypes.CHANGERECRUITMENTSETTING,
		payload: {
			filters: filters,
			status: status,
			counter: counter
		}
	}
}
export function changeRecruitmentSetting (filters = {}, status = "loading", counter = 1) {
	return dispatch => dispatch(changeRecruitmentSettingAction(filters, status, counter));
}
export function selectRecruitmentSetting (gets, callback) {
	let apiLoadStatus = false;
	return dispatch => {
		recruitmentSettingService.selectRecruitmentSetting(gets, res => {
			apiLoadStatus = true;
			if (res.data.Success || 1 === dataMode) {
				dispatch({
					type: RecruitmentConstants.ActionTypes.SELECTRECRUITMENTSETTING,
					payload: {
						data: res.data,
						status: "loaded"
					}
				});
			}else{
				dispatch(changeRecruitmentSettingAction({}, "error", 0));
			}
		}, err => {
			apiLoadStatus = true;
			dispatch(changeRecruitmentSettingAction({}, "error", 0))
		})
		setTimeout(() => {
			if (!apiLoadStatus) {
				dispatch(changeRecruitmentSettingAction({}, "loading", 0))
			}
		}, 100);
	}
}
export function updateRecruitmentSetting (puts, index, callback) {
	return dispatch => recruitmentSettingService.updateRecruitmentSetting(puts, res => {
		if ("function" === typeof callback) {
			callback(res);
		}
		if (res.data.Success) {
			dispatch({
				type: RecruitmentConstants.ActionTypes.UPDATERECRUITMENTSETTING,
				payload: {
					data: puts,
					index: index
				}
			})
		}
	})
}



// recruistment statistics
function changeRecruitmentStatisticsAction (filters = {}, status = "loading", counter = 1) {
	return {
		type: RecruitmentConstants.ActionTypes.CHANGERECRUITMENTSTATISTICS,
		payload: {
			filters: filters,
			status: status,
			counter: counter
		}
	}
}
export function changeRecruitmentStatistics (filters = {}, status = "loading", counter = 1) {
	return dispatch => dispatch(changeRecruitmentStatisticsAction(filters, status, counter));
}
export function selectRecruitmentStatistics (gets, callback) {
	let apiLoadStatus = false;
	return dispatch => {
		recruitmentStatisticsService.selectRecruitmentStatistics(gets, res => {
			apiLoadStatus = true;
			if (res.data.Success || 1 === dataMode) {
				dispatch({
					type: RecruitmentConstants.ActionTypes.SELECTRECRUITMENTSTATISTICS,
					payload: {
						data: res.data,
						status: "loaded"
					}
				});
			}else{
				dispatch(changeRecruitmentStatisticsAction({}, "error", 0));
			}
		}, err => {
			apiLoadStatus = true;
			dispatch(changeRecruitmentStatisticsAction({}, "error", 0))
		})
		setTimeout(() => {
			if (!apiLoadStatus) {
				dispatch(changeRecruitmentStatisticsAction({}, "loading", 0))
			}
		}, 100);
	}
}




// resume library
function changeResumeLibraryAction (filters = {}, status = "loading", counter = 1) {
	return {
		type: RecruitmentConstants.ActionTypes.CHANGERESUMELIBRARY,
		payload: {
			filters: filters,
			status: status,
			counter: counter
		}
	}
}
export function changeResumeLibrary (filters = {}, status = "loading", counter = 1) {
	return dispatch => dispatch(changeResumeLibraryAction(filters, status, counter));
}
export function selectResumeLibrary (gets, callback) {
	let apiLoadStatus = false;
	return dispatch => {
		resumeLibraryService.selectResumeLibrary(gets, res => {
			apiLoadStatus = true;
			if (res.data.Success || 1 === dataMode) {
				dispatch({
					type: RecruitmentConstants.ActionTypes.SELECTRESUMELIBRARY,
					payload: {
						data: res.data.Object.resumes,
						status: "loaded",
						positions: res.data.Object.positions
					}
				});
			}else{
				dispatch(changeResumeLibraryAction({}, "error", 0));
			}
		}, err => {
			apiLoadStatus = true;
			dispatch(changeResumeLibraryAction({}, "error", 0));
		})
		setTimeout(() => {
			if (!apiLoadStatus) {
				dispatch(changeResumeLibraryAction({}, "loading", 0))
			}
		}, 100);
	}
}
export function updateResumeLibrary (puts, index, callback) {
	return dispatch => resumeLibraryService.updateResumeLibrary(puts, res => {
		if ("function" === typeof callback) {
			callback(res);
		}
		if (res.data.Success) {
			dispatch({
				type: RecruitmentConstants.ActionTypes.UPDATERESUMELIBRARY,
				payload: {
					data: puts,
					index: index
				}
			})
		}
	})
}






// WEBPACK FOOTER //
// ./src/actions/recruitment-actions.js